<template>
  <v-app>
    <v-main>
      <v-container fluid class="fill-height pa-0">
        <v-row no-gutters class="fill-height">
          <!-- Left Side - Branding/Image -->
          <v-col
            cols="12"
            md="7"
            class="d-none d-md-flex login-banner"
          >
            <div class="banner-content">
              <div class="banner-overlay"></div>
              <div class="banner-text">
                <img
                  src="/gpa_logo.png"
                  alt="GPA Logo"
                  class="gpa-logo mb-6"
                />
                <h1 class="text-h2 font-weight-bold text-grey-darken-4 mb-4">Board Matters</h1>
                <p class="text-h6 text-grey-darken-2 mb-6">
                  Digital Board Management System for Gambia Ports Authority
                </p>
                <div class="features-list">
                  <div class="feature-item">
                    <v-icon color="primary" class="mr-3">mdi-check-circle</v-icon>
                    <span class="text-grey-darken-3">Meeting Management</span>
                  </div>
                  <div class="feature-item">
                    <v-icon color="primary" class="mr-3">mdi-check-circle</v-icon>
                    <span class="text-grey-darken-3">Attendance Tracking</span>
                  </div>
                  <div class="feature-item">
                    <v-icon color="primary" class="mr-3">mdi-check-circle</v-icon>
                    <span class="text-grey-darken-3">Resolution Management</span>
                  </div>
                  <div class="feature-item">
                    <v-icon color="primary" class="mr-3">mdi-check-circle</v-icon>
                    <span class="text-grey-darken-3">Analytics & Reporting</span>
                  </div>
                </div>
              </div>
            </div>
          </v-col>

          <!-- Right Side - Login Form -->
          <v-col
            cols="12"
            md="5"
            class="d-flex align-center justify-center login-form-container"
          >
            <div class="login-form-wrapper">
              <!-- Mobile Logo -->
              <div class="text-center mb-8 d-md-none">
                <img
                  src="/gpa_logo.png"
                  alt="GPA Logo"
                  class="gpa-logo mobile"
                />
                <h2 class="text-h5 mt-4 text-primary">Board Matters</h2>
              </div>

              <!-- Router View (Login Form) -->
              <router-view />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'AuthLayout'
}
</script>

<style scoped>
.login-banner {
  position: relative;
  background: #ffffff;
  overflow: hidden;
}


.banner-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.3;
}

.banner-text {
  position: relative;
  z-index: 1;
  max-width: 600px;
  text-align: left;
}

.features-list {
  margin-top: 3rem;
}

.feature-item {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  font-size: 1.1rem;
}

.login-form-container {
  background: linear-gradient(to bottom, #f5f5f5 0%, #ffffff 100%);
  min-height: 100vh;
}

.login-form-wrapper {
  width: 100%;
  max-width: 480px;
  padding: 2rem;
}

.gpa-logo {
  width: 96px;
  height: auto;
}

.gpa-logo.mobile {
  width: 72px;
}

/* Mobile Responsiveness */
@media (max-width: 960px) {
  .login-form-wrapper {
    padding: 1rem;
  }

  .banner-text h1 {
    font-size: 2rem !important;
  }

  .banner-text p {
    font-size: 1rem !important;
  }
}
</style>